import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { NmDatatableSettings } from '../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'members-pending-page',
	templateUrl: './pending.html',
	styleUrls: ['./pending.css']
})
export class MembersPendingPage {
	public modelName: string = 'member';
	public batchBtnStatus: boolean = true;
	public reloadTable: boolean = false;
	public searched: boolean = false;

	public form: FormGroup = this.formBuilder.group({
		// basic information
		file: ['',Validators.required],
	});
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _form: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}


	public searchForm: FormGroup = this.formBuilder.group({
		// basic information
		// YFSID: [''],
		// LegacyYFSID: [''],
		// HongKongIdentityCard: [''],
		// FullName: [''],
		// ChineseName: [''],
		// SchoolId: [''],
		// DateOfBirth: [''],
		// EmailAddress: [''],
		// Telephone1: [''],
		// Telephone2: [''],
		// StatusCode: [''],
		// year: [''],
		// early_bird: ['']
		import_status: ['']
	});

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this._form.setForm(this.form);
		this.onBeforeRendered();

		let params = this.activatedRoute.snapshot.queryParams;
		
		let initSearch: boolean = false;
		for(let key in params){
			if(params[key] && this.searchForm.controls[key]){
				this.searchForm.controls[key].setValue(params[key]);
				initSearch = true;
			}
		}
		if(initSearch){
			this.onSearch();
		}
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}
	public onSubmit(): void {
		this.batchBtnStatus = false;
		let data = JSON.parse(JSON.stringify(this.form.value)); // copy

		console.log(data);
		//return false;
		// stop from page
		if(data === false)
			return;

		if(this.form.valid) {
			try {
				let promise;
				promise = this.api.sendApiRequest('post', 'member/batchupload', data).toPromise();
				

				promise
				.then(res => {
					this.onAfterSubmit(true);
					this.batchBtnStatus = true;
					this.reloadTable = true;
				})
				.catch(err => {
					this.onAfterSubmit(false);
					this.batchBtnStatus = true;
				});
			}
			catch(e) {
				console.error(e);
					this.batchBtnStatus = true;
			}
		}
		else {
			this._form.showErrors();
		}
	}
	public onAfterSubmit(success: boolean): void {
		if(success) {
			bootbox.alert({
				message: 'success uploaded',
				callback:() => {
					
				}
			});
		}
	};
	

	public datatableSetting: NmDatatableSettings = {
		modelName: 'member',
		fields: [
			//{ name: 'YFSID', label: 'YFS ID', sortable: true, searchable: true },
			//{ name: 'LegacyYFSID', label: 'Legacy YFS ID' },
			// { name: 'HongKongIdentityCard', label: 'HKID' },
            { name: 'SchoolId', label: 'School ID' },
			{ name: 'engName', label: 'Name (English)' },
			{ name: 'ChineseName', label: 'Name (Chinese)', searchable: true },
			{ name: 'schoolEngName', label: 'School Name (English)' },
			{ name: 'schoolChiName', label: 'School Name (Chinese)' },
			{ name: 'DateOfBirth', label: 'Date of Birth (dd/mm/yyyy)' },
			{ name: 'EmailAddress', label: 'Email', searchable: true },
			{ name: 'Telephone1', label: 'Tel (Home)', searchable: true },
			{ name: 'Telephone2', label: 'Tel (Mobile)', searchable: true },
			{ name: 'import_status', label: 'Action',sortable: true, searchable: true}
			// TODO: remove dummy, use date_joined and last_purchase_date
			// { name: 'home_address', label: 'Date Joined' },
			// { name: 'office_address', label: 'Last Purchase Date' },

			// { name: 'mobile_phone', label: 'Mobile Number' },
			// { name: 'status', label: 'Status' },
		],
		actions: [
			{ name: 'matchrenew', icon: 'check', label: 'Renew as old member', color: 'blue', show: (id,data) => (data.import_status=='<span class="red">Manual match</span>'?true:false), callback: function(id: string, data: any): void {
			bootbox.prompt('YFS ID', (YFSID) => {
				if(YFSID) {
					this.dataService[this.settings.modelName].matchrenew(id,YFSID)
					.then(() => this.reload());
				}else if(YFSID === ''){
					return false;
				}
			});
		}},
		{ name: 'matchasnew', icon: 'check', label: 'Make this as new member', color: 'blue', show: (id,data) => (data.import_status=='<span class="red">Manual match</span>'?true:false), callback: function(id: string, data: any): void {
		bootbox.confirm('Are you sure to make this as new member?', (ok) => {
				if(ok) {
					this.dataService[this.settings.modelName].matchasnew(id)
					.then(() => this.reload());
				}
			});
		}},
			{ name: 'matchdelete', icon: 'trash', color: 'red', show: (id,data) => (data.import_status=='<span class="red">Manual match</span>'?true:false), callback: function(id: string, data: any): void {
			bootbox.confirm('Are you sure to ignore this match?', (ok) => {
				if(ok) {
					this.dataService[this.settings.modelName].matchdelete(id)
					.then(() => this.reload());
				}
			});
		}},
		],
		ajax: {
			url: 'member/manualdatatables'
		},
		ajaxDataMassage: (data: any[]) => {
			return data.map(v => {
				// parse json string
				for(let i of ['name', 'mobile_phone']) {
					if(v[i] && typeof v[i] == 'string')
						v[i] = this.helper.parseJsonString(v[i]);
				}
				v.id = v.id;
				v.engName = v.Surname+' '+v.GivenName;
				v.schoolEngName = v.school?v.school.NameSchool:'';
				v.schoolChiName = v.school?v.school.NameChin:'';
				if(v.DateOfBirth){
					let birthArr:number[] = v.DateOfBirth.split('-');
					v.DateOfBirth = birthArr[2]+'/'+birthArr[1]+'/'+birthArr[0];
				}

				if(v.import_status == 'added'){
					v.import_status = 'New member';
				}else if(v.import_status == 'renewed'){
					v.import_status = 'Old member';
				}else if(v.import_status == 'pending'){
					v.import_status = '<span class="red">Manual match</span>';
				}else if(v.import_status == 'ignored'){
					v.import_status = 'Ignored';
				}
				let matchStatus = eval('('+v.match_status.replace(/&quot;/g,'"')+')');
				if(matchStatus.Surname){
					v.engName = '<i class="fa fa-check-circle green"></i> '+ v.engName;
				}else{
					v.engName = '<i class="fa fa-times-circle red"></i> '+ v.engName;
				}
				if(matchStatus.HongKongIdentityCard ){
					v.HongKongIdentityCard = '<i class="fa fa-check-circle green"></i> '+ v.HongKongIdentityCard;
				}else{
					v.HongKongIdentityCard = '<i class="fa fa-times-circle red"></i> '+ v.HongKongIdentityCard;
				}
				// if(matchStatus.ChineseName ){
				// 	v.ChineseName = '<i class="fa fa-check-circle green"></i> '+ v.ChineseName;
				// }else{
				// 	v.ChineseName = '<i class="fa fa-times-circle red"></i> '+ v.ChineseName;
				// }
				if(matchStatus.DateOfBirth ){
					v.DateOfBirth = '<i class="fa fa-check-circle green"></i> '+ v.DateOfBirth;
				}else{
					v.DateOfBirth = '<i class="fa fa-times-circle red"></i> '+ v.DateOfBirth;
				}
                if(matchStatus.EmailAddress ){
                    v.EmailAddress = '<i class="fa fa-check-circle green"></i> '+ v.EmailAddress;
                }else{
                    v.EmailAddress = '<i class="fa fa-times-circle red"></i> '+ v.EmailAddress;
                }
				if(typeof matchStatus.telMatch != 'undefined'){
					if(matchStatus.telMatch){
						v.Telephone1 = '<i class="fa fa-check-circle green"></i> '+ v.Telephone1;
                        v.Telephone2 = '<i class="fa fa-check-circle green"></i> '+ v.Telephone2;
					}else{
                        v.Telephone1 = '<i class="fa fa-times-circle red"></i> '+ v.Telephone1;
                        v.Telephone2 = '<i class="fa fa-times-circle red"></i> '+ v.Telephone2;
					}
				}
				return v;
			})
		}
	};

	public onSearch():void{
		//console.log(this.searchForm.value);
		let fullMath = ['SchoolId','StatusCode'];
		this.datatableSetting.fields.map(v => {
			this.searchForm.value[v.name] ? v.search = this.searchForm.value[v.name] : v.search = '';
			for(let k of fullMath){
				if(v.search && v.name == k){
					v.regex = true;
					v.search = '^'+v.search+'$';
				}
			}
			
			return v;
		});
		
		//console.log(this.datatableSetting);
		this.searched = true;
		this._setSearchUrl();
	}
	private _setSearchUrl(){
		let querys = [];
		for(let name in this.searchForm.value){
			if(this.searchForm.value[name]){
				querys.push(name+'='+this.searchForm.value[name]);
			}
		}
		
		let queryStr = querys.join('&');
		if(!queryStr){
			queryStr = 'searchall=1';
		}
		this.location.replaceState('/members/pending',queryStr);
		
	}

	public onSearchClear(): void{
		/*$('select').val(null);
		$('select').trigger('chosen:updated');
		this.searchForm.reset();*/
		for(let it in this.searchForm.controls){
			this.searchForm.controls[it].setValue('');
		}
		$('select').val(null);
		$('select').trigger('chosen:updated');
	}
	public onBackSearch(): void{
		this.searched = false;
	}
}



// WEBPACK FOOTER //
// ./src/pages/members/pending/pending.ts